//  Node imports
import { IEvent, delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import {
  FreeGameController,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-leopard/dist";
import { SlotEventConstants } from "@quest/slot-core";

//  Class impotrs
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { EventConstantsLeander } from "@quest/oddsworks-platform";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class FreeGameControllerGame extends FreeGameController {
  // freegameBgSpineContainer: any;
  // freegameBgSpine: SpineBase;

  protected initializeComponents(): void {
    super.initializeComponents();
    // this.freegameBgSpineContainer = this.view.getContainerByID("freegameBgSpineContainer");
    // this.freegameBgSpine = this.view.getSpineById("freegame_idle_desktop") as SpineBase;
    this.hideAutoplayButtons();
    this.hideTurboButtons();
  }
  /**
   * To subscibe freegame events
   */
  protected subscribeEvents() {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.HIDE_STATIC_SYMBOL_BEHIND_STACK_FG, this.hideStaticSymbol, this);
    dispatcher.on(eventDispatchers.SHOW_STATIC_SYMBOL_BEHIND_STACK_FG, this.showStaticSymbol, this);
  }
  /**
   * To unsubscibe freegame events
   */
  protected unsubscribeEventsFG() {
    super.unsubscribeEventsFG();
    dispatcher.off(eventDispatchers.HIDE_STATIC_SYMBOL_BEHIND_STACK_FG, this.hideStaticSymbol, this);
    dispatcher.off(eventDispatchers.SHOW_STATIC_SYMBOL_BEHIND_STACK_FG, this.showStaticSymbol, this);
  }
  /**
   * play freeagme bg spine
   */
  protected onShowFreeGame(): void {
    super.onShowFreeGame();
    this.playFreegameIdleSpine();
    ingenuity.soundManager.stop(SoundConstantGame.FREEGAME_INTRO_VOICE, "soundList_1");
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
  }
  /**
   * to show static of stack symbols on fg end
   */
  public freeGameOutroShow(evt: IEvent): void {
    super.freeGameOutroShow(evt);
    dispatcher.fireEvent(eventDispatchers.SHOW_STATIC_SYMBOL_BEHIND_STACK_FG);
    dispatcher.fireEvent(eventDispatchers.SHOW_STATIC_STICKY_WILD);
  }
  /**
   * play freeagme bg spine
   */
  protected playFreegameIdleSpine(): void {
    // this.freegameBgSpineContainer.visible = true;
    // this.freegameBgSpine.playAnim(SlotConstantsBehavior.FREEGAME_IDLE_SPINE, true);
  }
  /**
   * Override to update bottom bar win in broken
   */
  protected checkBrokenGame(): void {
    if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREESPIN_LABEL_COUNT);
      dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_BOTTOM_BAR_WIN, {
        value: this.model.getTotalWinAmt().toString(),
      });
      delayedCall(
        "showFreeGameDelay",
        500,
        function () {
          killDelayedCall("showFreeGameDelay");
          dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREESPIN_LABEL_COUNT);
          dispatcher.fireEvent(SlotEventConstants.FG_RESET_METERS);
          dispatcher.fireEvent(SlotEventConstants.SUBSCRIBE_EVENTS_ON_REEL_START);
          dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BROKEN_GAME_FG);
          dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW);
          (ingenuity.parserModel as GameParserModel).setFreeGameBroken(false);
        },
        this
      );
      dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_BOTTOM_BAR_WIN, {
        value: (ingenuity.parserModel as GameParserModel).getTotalWin().toString(),
      });
      dispatcher.fireEvent(EventConstantsLeander.TOTAL_WIN_UPDATED, {
        winAmount: ingenuity.parserModel.getTotalWin().toFixed(2),
      });
    }
  }
  /**
   * reset data on freegame reset
   */
  protected resetFreeGame(): void {
    (ingenuity.parserModel as GameParserModel).setCurrentFreeSpinCount(0);
    (ingenuity.parserModel as GameParserModel).setFreeSpinNum(0);
    (ingenuity.parserModel as GameParserModel).setFreeSpinWinAmt(0);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_WIN_VALUE_TO_DEFAULT);
    dispatcher.fireEvent(SlotEventConstants.FG_DISABLED_ALL_BUTTONS);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SUBSCRIBE_BASEVIEW_EVENTS);
    this.playerMsgController.unSubscribeFreeGameEvents();
  }
  /**
   * function to hide static symbol which are not taking part in win toggle
   */
  private hideStaticSymbol(evt: IEvent): void {
    const offset = this.view.getReelView().getSymbolByPos(evt.data[0] - 1, evt.data[1]);
    const staticSym = offset.getStatic();
    staticSym.visible = false;
  }
  /**
   * to show all static symbol
   */
  private showStaticSymbol(evt: IEvent): void {
    for (let i = 0; i < ingenuity.configData.numberOfReel; i++) {
      for (let j = 0; j < ingenuity.configData.symPerReel[0]; j++) {
        const offset = this.view.getReelView().getSymbolByPos(i, j);
        const staticSym = offset.getStatic();
        staticSym.visible = true;
      }
    }
  }
  /**to show game logo  */
  protected showGameLogo(): void {
    if (ingenuity.deviceEnv.isDesktop) {
      this.gameLogo.visible = true;
    }
  }
  protected showFreegameWithAlphaTween() {
    this.view.visible = true;
    this.view.alpha = 0.2;
    const freeGameFadeIn = ingenuity.currentGame.add
      .tween(this.view)
      .to({ alpha: 1 }, SlotConstantsBehavior.FREE_GAME_FADE_IN_TIME, undefined, true);
    freeGameFadeIn.onComplete.add(() => {
      ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT && this.view.onShowPortraitButtonpanel();
      ingenuity.currentGame.tweens.remove(freeGameFadeIn);
      freeGameFadeIn.stop();
    }, this);
    this.view.getContainerByID("portraitButtonsContainer") &&
      (this.view.getContainerByID("portraitButtonsContainer").visible = true);
    this.view.getContainerByID("topPortraitButtonsContainer") &&
      (this.view.getContainerByID("topPortraitButtonsContainer").visible = true);
  }
}
